
import { useEffect, useState } from 'react';
import {useParams,useNavigate} from "react-router-dom";
import Logo from '@/assets/img/user-side-logo.svg';
import { Pet } from '@/features/availability/types';
import 'react-calendar/dist/Calendar.css';
import { isMobile } from 'react-device-detect';
import storage from '@/utils/storage';
import { Profile } from '@/features/auth/routes/Profile';
import { useAuth } from '@/lib/auth';
import { Register } from '@/features/auth/routes/Register';
import { ParentProfile } from '@/features/availability/components/ParentProfile';
import { Login } from '@/features/auth/routes/Login';
import { ForgotPassword } from '@/features/auth/routes/ForgotPassword';
import '../components/css/Availablity.css'
import { loadStripe } from '@stripe/stripe-js';
import { VerifyOtp } from '@/features/auth/routes/VerifyOtp';
import { useGetPetsList } from '../api/getPetsList';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY as string);

export const LoginPage = () => {
  const {slag} = useParams();
  const { user,refetchUser } = useAuth();
  const [selectedValues, setSelectedValues] = useState(false);
  const [ addNewPet ,setAddNePet] = useState(false)
  const useGetEventsMutation = useGetPetsList();

  const [petsList, setPetsList] = useState<Pet[]>();
 
  const [dinnerWidth, setInnerHeight] = useState(window.innerWidth);
  const [screen, setScreen] = useState(0);
  const [stack, setStack] = useState([]);

  const navigate = useNavigate();
  const slug = storage.getKey('slug');
  const handleResize = () => {
    setInnerHeight(window.innerWidth);
  };
  function pushNumber(number:any) {
    const newStack:any = [...stack, number];
    setStack(newStack);
    setScreen(number);
  }

  useEffect(() => {
    if(user){
       navigate(`/shops`);
      fetchPets(false);
    }
  }, []);

   useEffect(() => {
    if (getScreenState() != screen) {
      pushNumber(getScreenState());
    }
  }, [user,user?.pets]);

  const fetchPets = async (isPast: boolean) => {
    const res = await useGetEventsMutation.mutateAsync({
      businessId: user?.businessId,
      page: 1,
      perPage: 100,
      isPast: isPast,
    });
    setPetsList(res.list);
  };

  const getScreenState = () => {
    if (user && user.email) {
      if (user.firstName && user.lastName && user.address && user.city && user.state && user.zip) {
        if (user.pets && user.pets.length > 0) {
          if(user.defaultCard)
          {
          return 6;
          }
          return 5;
        }
        return 4;
      }
      return 3;
    }
    return 0;
  };


  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function getTopElement(newStack:any) {
    if (newStack.length > 0) {
      return newStack[newStack.length - 1];
    } else {
      return 0;
    }
  }

  function popNumber() {
    const newStack = [...stack];
    newStack.pop()
    setStack(newStack);
    setScreen(getTopElement(newStack));
  }

  const getScreen = () => {
    if (screen === -2) {
      return (
        <ForgotPassword
          onSuccess={async () => {
            pushNumber(0);
          }}
          onBackClick={() => {
            popNumber();
          }}
        />
      );
    }
    if (screen === -1) {
      return (
        <VerifyOtp
          onSuccess={async () => {
            await refetchUser();
            fetchPets(false);
            pushNumber(3);
          }}
          onBackClick={() => {
            popNumber();
          }}
        />
      );
    }
    if (screen === 0) {
      return (
        <Profile
        onClickBtn={(type: any) => {
          pushNumber(type);
        }}
          onBackClick={() => {
            close();
            setSelectedValues(false)
          }}
        />
      );
    }
    if (screen === 1) {
      return (
        <Register
          onSuccess={async() => {
            pushNumber(-1);
          }}
          onBackClick={() => {
            popNumber();
          }}
          goToLogin={() => {
            pushNumber(2);
          }}
          
        />
      );
    }  if (screen === 2) {
      return (
        <Login
        onSuccess={async() => {
          await refetchUser();
          fetchPets(false);
          navigate(`/shops`);
        }}
          onBackClick={() => {
            popNumber();
          }}
          requiredEmailVerification={()=>{
            pushNumber(-1);
          }}
        
        />
      );
    }else if (screen === 3) {
      return (
        <ParentProfile
          onSuccess={async() => {
            await refetchUser();
            pushNumber(4);
          }}
          onBackClick={() => {
            if (user && user.email) {
              setSelectedValues(false)
            } else {
              pushNumber(2);
            }
          }}
        />
      );
    } else if (screen === 4) {
      return (
        null
      );
    } 
    else if (screen === 5 && user) {
      return <></>
    }
  }

  return (<>
    <div className="main-layout"><>
      <img alt="" src={Logo} className="user-logo" />  
      {!isMobile && <div className="page-title refresh-title booking-screen-only">
        <img alt="" src={Logo} className="user-logo-mobile" />
      </div>}
      </>
      <div className="calender-row">
        <div className="event-list">
         <div className="login-details-card">
        {getScreen()}  
        <div>
           </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
